import {DICT_KEY, getDictNameByCode, getModel, setModel} from "../../../utils/constants";
import ModelUtils from "../../../utils/ModelUtils";
import StockStatisticService from "../../stock/statistic/StockStatisticService";
import PurchasePoService from "./PurchasePoService";
import moment from "moment";
import {v4 as uuid} from "uuid";

const MODEL_KEY = DICT_KEY.PURCHASE_PO;
const storageModel = getModel(MODEL_KEY);

//转换日期函数
function transRangePickerValue(obj, ...values) {
    if (!!!obj) return null;
    let tmp = obj;
    for (let i = 0; i < values.length; i++) {
        if (tmp[values[i]]) {
            tmp = tmp[values[i]]
        } else {
            break;
        }
        if (i === values.length - 1) {
            tmp[0] = moment(tmp[0])
            tmp[1] = moment(tmp[1])
        }
    }
}

// transRangePickerValue(storageModel, "searchParam", "startEndDate");

const cacheAble = false;
const initModel = {
    //查询参数
    searchParam: {},
    //单据列表
    documentList: [],
    //销售订单统计信息
    documentStatistic: {
        amountPaidTotal: 0.00,
        amountPayableTotal: 0.00,
        purchaseAmountTotal: 0.00,
        purchaseQuantityTotal: 0,
    },
    //单据列表分页信息
    documentPageInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 15
    },
    //选中单据
    selectedDocument: {},
    //选中单据key数组
    selectedDocumentRowKeys: [],
    //单据打印窗口显示
    printDocumentModelVisible: false,


    //单据配件列表
    documentMaterialList: [],
    //选中配件(废弃)
    selectedDocumentMaterial: {},
    //选中配件key数组
    selectedDocumentMaterialRowKeys: [],
    //明细统计信息
    detailStatistics: {
        poTotalNum: 0,
        poPayableAmount: 0,
        poTotalAmount: 0,
    },

    //添加物料窗口显示
    addMaterialModelVisible: false,
    materialSearchParam: {},
    //待选配件列表
    materialList: [],
    materialPageInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 5
    },
    //已选配件列表
    selectedMaterialList: [],
    paymentDrawerVisible: false,
    transferDrawerVisible: false,
    formExpand: false,
    formData: {},
};
const purchasePoModel = {
    state: cacheAble && storageModel ? storageModel : initModel,
    reducers: {
        init(state,) {
            state = {...initModel};
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        toggleExpand(state,) {
            state.formExpand = !state.formExpand;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setFormData(state, payload) {
            state.formData = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setSearchParam(state, payload) {
            state.searchParam = {...state.searchParam, ...payload};
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        clearSearchParam(state,) {
            state.searchParam = {};
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setDocumentList(state, payload) {
            state.documentList = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setDocumentStatistic(state, payload) {
            state.documentStatistic = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setDocumentPageInfo(state, payload) {
            state.documentPageInfo = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setSelectedDocument(state, payload) {
            state.selectedDocument = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setSelectedDocumentRowKeys(state, payload) {
            state.selectedDocumentRowKeys = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setPrintDocumentModelVisible(state, payload) {
            state.printDocumentModelVisible = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setDetailStatistics(state, payload) {
            state.detailStatistics = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setDocumentMaterialList(state, payload) {
            state.documentMaterialList = payload;

            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        //添加单据中的配件信息
        addDocumentMaterial(state, payload) {
            state.documentMaterialList.push(...payload);
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        //移除单据中的配件信息
        removeDocumentMaterial(state, payload) {
            state.documentMaterialList = state.documentMaterialList.filter(el => !!!payload.find(ele => ele === el.key));
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        //设置单据中选中的配件
        setSelectedDocumentMaterial(state, payload) {
            state.selectedDocumentMaterial = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setSelectedDocumentMaterialRowKeys(state, payload) {
            state.selectedDocumentMaterialRowKeys = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },

        setAddMaterialModelVisible(state, payload) {
            state.addMaterialModelVisible = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setMaterialSearchParam(state, payload) {
            state.materialSearchParam = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        //待选配件列表
        setMaterialList(state, payload) {
            state.materialList = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setMaterialPageInfo(state, payload) {
            state.materialPageInfo = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setSelectedMaterialList(state, payload) {
            state.selectedMaterialList = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        //添加已选配件
        addSelectedMaterial(state, payload) {
            let {selectedMaterialList } = state
            let filterMater = selectedMaterialList.filter(elem=>elem.id==payload.id)
            // console.log(filterMater.length)
            state.selectedMaterialList.push({...payload,key:payload.key+filterMater.length});
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        //删除已选配件
        removeSelectedMaterial(state, payload) {
            // state.materialList.push(payload);
            state.selectedMaterialList = state.selectedMaterialList.filter(el => el.id !== payload.id);
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        //设置支付窗口显示
        setPaymentDrawerVisible(state, payload) {
            state.paymentDrawerVisible = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        //设置转销售单窗口显示状态
        setTransferDrawerVisible(state, payload) {
            state.transferDrawerVisible = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        //选中库存列表转化为采购单明细列表
        transSelectedStockItemListToPoItemList(state,) {
            const mappedItems = state.selectedMaterialList.map( el => {
                let tmp = stockItemMapToPoItem(el);
                const {purchaseNum, giftsNum, purchasePrice, discount, warehouseId, shelfId} = tmp
                tmp.purchaseAmount = ((purchaseNum - giftsNum) * purchasePrice * discount / 100).toFixed(2);
                tmp.warehouseName = getDictNameByCode(DICT_KEY.CM_DICT.WAREHOUSE, warehouseId);
                tmp.shelfCode = getDictNameByCode(DICT_KEY.CM_DICT.POSITION, shelfId);
                return tmp;
            })
            // console.log(mappedItems);
            state.documentMaterialList = [...state.documentMaterialList, ...mappedItems]
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        updateStatus(state, status) {
            /*state.documentMaterialList = state.documentMaterialList.map(el => el.id === id ? {
                ...el,
                orderStatus: status
            } : el);*/
            state.selectedDocument = {...state.selectedDocument, ...status}
            // console.log(status)
        },
    },
    effects: () => ({
        //加载单据列表
        async loadDocumentList({showMsg = true, duration = 5, data}) {
            const funName = "加载采购单列表";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await PurchasePoService.findPage(data);
                const {list, statistics, ...page} = retData;
                const mappedList = list.map(el => ({
                    ...el,
                    key: el.id,
                    orderStatusName: getDictNameByCode(DICT_KEY.CM_DICT.PURCHASE_STATUS, el.orderStatus),
                    invoiceTypeName: getDictNameByCode(DICT_KEY.CM_DICT.INVOICE_TYPE, el.invoiceType),
                    orderTypeName: getDictNameByCode(DICT_KEY.CM_DICT.PURCHASE_ORDER_TYPE, el.orderType),
                    paymentStatusName: getDictNameByCode(DICT_KEY.CM_DICT.PURCHASE_PAY_STATUS, el.paymentStatus),
                }))
                this.setDocumentList(mappedList);
                this.setDocumentStatistic(statistics);
                const {pageNum = 1} = page;
                this.setDocumentPageInfo({...page, pageNum: pageNum === 0 ? 1 : pageNum});
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        async loadPo({showMsg = true, duration = 5, data}) {
            const funName = "加载采购单详细信息";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await PurchasePoService.findByIdOrCode(data);
                const {details, ...po} = retData;
                // details.forEach(el => el.key = el.id);
                // console.log(retData, details);
                const mappedList = details.map(el => ({
                    ...el,
                    key: el.id,
                    materialUnitName: getDictNameByCode(DICT_KEY.CM_DICT.MATERIAL_UNIT, el.materialUnit)
                }))

                this.setSelectedDocument({
                    ...po,
                    orderStatusName: getDictNameByCode(DICT_KEY.CM_DICT.PURCHASE_STATUS, po.orderStatus),
                });
                this.setDocumentMaterialList(mappedList);
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        //新增订单
        async insert({showMsg = true, duration = 5, data}) {
            const funName = "新增采购单";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await PurchasePoService.insert(data);
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        //修改订单
        async update({showMsg = true, duration = 5, data}) {
            const funName = "修改采购单";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await PurchasePoService.update(data);
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },

        //作废
        async disable({showMsg = true, duration = 5, data}) {
            const funName = "采购单作废";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await PurchasePoService.disable(data);
                if (retData) {
                    this.updateStatus({
                        orderStatus: "025005",
                        orderStatusName: getDictNameByCode(DICT_KEY.CM_DICT.PURCHASE_STATUS, "025005")
                    });
                }
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        //库房确认
        async whConfirm({showMsg = true, duration = 5, data}) {
            const funName = "采购单库房确认(入库)";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await PurchasePoService.whConfirm(data);
                if (retData) {
                    // this.updateStatus("025003");
                    this.updateStatus({
                        orderStatus: "025003",
                        orderStatusName: getDictNameByCode(DICT_KEY.CM_DICT.PURCHASE_STATUS, "025003")
                    });
                }
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },

        //结算
        async settle({showMsg = false, duration = 5, data = {pageSize: 5}}) {
            const funName = "采购单结算";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await PurchasePoService.settle(data);
                if (retData) {
                    // this.updateStatus("025004");
                    this.updateStatus({
                        orderStatus: "025004",
                        orderStatusName: getDictNameByCode(DICT_KEY.CM_DICT.PURCHASE_STATUS, "025004")
                    });
                }
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        async transfer({showMsg = false, duration = 5, data}) {
            const funName = "转销售单";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await PurchasePoService.shift(data);
                if (retData) {
                    /*this.updateStatus({
                        orderStatus: "025004",
                        orderStatusName: getDictNameByCode(DICT_KEY.CM_DICT.PURCHASE_STATUS, "025004")
                    });*/
                }
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        //导出采购单
        async exportPo({showMsg = false, duration = 5, data}) {
            const funName = "导出采购单";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await PurchasePoService.exportPo(data);
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func)
        },

        //下载采购明细导入模板
        async downloadDetailTpl({showMsg = false, duration = 5, data}) {
            const funName = "下载采购明细导入模板";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await PurchasePoService.downloadDetailTpl(data);
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func)
        },
        //加载库存
        async loadStockItem({showMsg = true, duration = 5, data}) {
            const funName = "加载库存信息";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await StockStatisticService.findPage(data);
                const {list, statistics, ...pageInfo} = retData;
                // list.forEach(el => el.key = el.id);
                const mappedList = list.map(el => ({
                    ...el,
                    // key: `${el.warehouseId}-${el.shelfCode}-${el.materialId}`,
                    key: el.id,
                    Num:1,
                    materialUnitName: getDictNameByCode(DICT_KEY.CM_DICT.MATERIAL_UNIT, el.materialUnit),
                    materialBrandName: getDictNameByCode(DICT_KEY.CM_DICT.BRAND, el.materialBrand),
                }))
                this.setMaterialList(mappedList);
                const {pageNum = 1} = pageInfo;
                this.setMaterialPageInfo({...pageInfo, pageNum: pageNum === 0 ? 1 : pageNum});
                // this.setMaterialPageInfo(page);
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
    })
}

//库存数据转换为采购单明细数据
const stockItemMapToPoItem = el => {
    const {
        key,
        id,
        materialId,
        materialCode,
        replaceNum,
        materialName,
        materialUnit,
        materialUnitName,
        // purchaseNum,
        purchasePrice,
        warehouseId,
        warehouseName,
        shelfId,
        shelfCode,
        inventoryNum,
        Num
    } = el;
    return {
        key: uuid(),
        id,
        purchaseId: null,
        materialId,
        materialCode,
        replaceNum,
        materialName,
        materialUnit,
        materialUnitName,
        purchaseNum: Num,
        purchasePrice: !!purchasePrice ? purchasePrice : 0.00,
        discount: 100,
        giftsNum: 0,
        purchaseAmount: 0,
        returnNum: 0,
        warehouseId: !!warehouseId ? warehouseId : '空',
        warehouseName: !!warehouseName ? warehouseName : '空',
        shelfId: !!shelfId ? shelfId : '空',
        shelfCode: !!shelfCode ? shelfCode : '空',
        detailsStatus: null,
        purchaseDesc: "无",
        inventoryNum
        // "deleteFlag": 0,
        // "createTime": "2020-08-18 09:58:12",
        // "updateTime": "2020-08-18 10:28:42",
        // "createUser": "业务员",
        // "updateUser": "tester",
    }
}
export default purchasePoModel;